import { useExams } from '../../hooks/react-query/use-exam';
import Error from '../shared/error';
import { APIErrorType } from '../../api';
import Loader from '../shared/loader';
import ExamList from './exam-list';
import Segment from '../shared/segment';
import ExamHeader from './exam-header';

function ExamsContainer() {
  const { isError, isLoading, data: exams, error } = useExams();

  if (isError) return <Error error={error as APIErrorType} />;
  if (isLoading) return <Loader />;
  if (!exams || exams.length === 0)
    return (
      <div>
        <ExamHeader />
        <Segment textAlign='center'>هیچ آزمونی یافت نشد.</Segment>;
      </div>
    );

  return (
    <div>
      <ExamHeader />
      <ExamList exams={exams} />
    </div>
  );
}

export default ExamsContainer;
